import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};

  button {
    display: inline-flex;
  }
`

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const StepContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;

  & > svg {
    cursor: pointer;
    margin-top: -16px;
    min-width: ${props => props.theme.size.S};
  }

  & > div {
    flex-grow: 1;
  }
`

export const StepNumber = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${props => props.theme.size.XS};
  height: ${props => props.theme.size.XS};
  border: ${props => props.theme.stroke.default} solid #4a4a4a;
  color: ${props => props.theme.colors.text.default};
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
  margin-top: -16px;
`
